import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockBackwards"
const ClockBackwardsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.838 2.948C10.096 1.817 12.695 1.569 15.124 2.255 17.555 2.94 19.64 4.51 20.975 6.654S22.79 11.363 22.33 13.845 20.5 18.55 18.486 20.073 13.963 22.313 11.448 22.083C8.935 21.85 6.596 20.688 4.895 18.822 3.193 16.96 2.25 14.525 2.25 12H3.75C3.75 14.15 4.553 16.224 6.003 17.813S9.443 20.392 11.585 20.589 15.865 20.175 17.58 18.877 20.464 15.687 20.856 13.572 20.836 9.272 19.7 7.446 16.787 4.283 14.717 3.698C12.647 3.114 10.434 3.325 8.511 4.288 6.994 5.049 5.747 6.236 4.909 7.689H7.384V9.187H2.518V3.757H4.018V6.284C4.981 4.876 6.291 3.723 7.838 2.948" />
          <path d="M11.625 6.75C12.453 6.75 13.125 7.42 13.125 8.25V11.69L15.22 13.783C15.805 14.37 15.805 15.319 15.22 15.905L11.625 12.31z" />
        </svg>
      }
    </span>
  )
}
export default ClockBackwardsIcon
